var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs"},[_c('ul',_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,class:{ 'is-active': tab.isActive }},[_c('a',{attrs:{"href":tab.href},on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._v(_vm._s(tab.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"tabs-details"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54cf3b86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widge/Tabs.vue
// module id = null
// module chunks = 